export const DEFAULT_DB_NAME='jodoll-measure-db';
export const DEFAULT_DB_VERSION=2;
export const LOG_VALID_TIME=90*24*60*60*1000;//日志存放时间，上传量体任务存放时间